import { combineReducers } from "redux";
import AuthReducers from "Reducers/AuthReducers";
import { configReducer } from "./ConfigReducer";
import { UserReducer } from "./UserReducer";
import { PharmacyReducer } from "./PharmacyReducer";
import { StaffReducer } from "./StaffReducer";
import { SurgeryReducer } from "./SurgeryReducer";
import { GroupReducer } from "./GroupReducer";
import { PatientReducer } from "./PatientReducers";
import { RepeatOrderReducer } from "./RepeatOrderReducer";
import { HomeReducer } from "./HomeReducer";
import { CollectionReducer } from "./CollectionReducers";
import { OrderPadReducer } from "./OrderPadReducers";
import { ActivityReducer } from "./ActivityReducer";
import { SimulatorReducer } from "./SimulatorReducer";

export default combineReducers({
  auth: AuthReducers,
  config: configReducer,
  user: UserReducer,
  pharmacy: PharmacyReducer,
  staff: StaffReducer,
  surgery: SurgeryReducer,
  group: GroupReducer,
  patient: PatientReducer,
  order: RepeatOrderReducer,
  home: HomeReducer,
  collection: CollectionReducer,
  orderPad: OrderPadReducer,
  activity: ActivityReducer,
  simulator: SimulatorReducer,
});
